import React, { Component, Suspense, lazy } from 'react'
import { Route, Switch } from 'react-router'

import { ShellRoute } from 'App/Shell'
import FourOFour from 'App/FourOFour'
import { ToggleFeature, features } from 'features/ToggleFeature'
import { RedirectContainer } from 'features/Redirect'
import Splash from 'App/Splash'

const Faq = lazy(() => import('features/Faq/Faq'))
const Contact = lazy(() => import('features/Contact/Contact'))
const FaqSelected = lazy(() => import('features/Faq/FaqSelected'))
const RedirectCash = lazy(() => import('features/RedirectCustom/RedirectCash/RedirectCash'))
const RedirectPoints = lazy(() => import('features/RedirectCustom/RedirectPoints/RedirectPoints'))

class RedirectCustom extends Component {
  render () {
    return (
      <Suspense fallback={<div />}>
        <Switch>
          <ShellRoute
            path='/redirect/vendor/:vendorId'
            component={RedirectContainer}
          />
          <Route
            path='/redirect/conexxe/:conexxePath'
            component={() => (
              <ToggleFeature
                feature={features.RedirectCustomConexxeFeature}
                default={FourOFour}
              />
            )}
          />
          <ShellRoute
            exact
            path='/redirect/faq'
            component={() => (
              <ToggleFeature
                feature={features.RedirectCustomZendeskFeature}
                default={Faq}
              />
            )}
            isGuest
          />
          <ShellRoute
            exact
            path='/redirect/contact'
            component={() => (
              <ToggleFeature
                feature={features.RedirectCustomZendeskFeature}
                default={Contact}
              />
            )}
            isGuest
          />
          <ShellRoute
            path='/redirect/faq/:section/:topic'
            component={FaqSelected}
            isGuest
          />
          <ShellRoute
            exact
            path='/redirect/sso'
            component={(props) => (
              <ToggleFeature
                feature={features.SSORedirect}
                default={Splash}
                {...props}
              />
            )}
            isGuest
          />

          <ShellRoute path='/redirect/cash'
            component={RedirectCash} />
          <ShellRoute path='/redirect/points'
            component={RedirectPoints} />

          <ShellRoute
            exact
            path='/redirect/shopping/:programme'
            component={(props) => (
              <ToggleFeature
                feature={features.ShoppingAuthenticate}
                default={Splash}
                {...props}
              />
            )}
            isGuest
          />

          <ShellRoute component={FourOFour} isGuest />
        </Switch>
      </Suspense>
    )
  }
}

export default RedirectCustom



// WEBPACK FOOTER //
// ./src/features/RedirectCustom/RedirectCustom.js